const BLOCKED_MONITORING_PERIOD_CODE = 'EA_BLOCKED_MONITORING_PERIOD'

export type BlockedMonitoringPeriodDetails = {
  carbonInstances: { id: string; name: string }[]
  blockedMonitoringPeriods: string[]
}

type BlockedMonitoringPeriodBody = {
  errorCode?: string
  errorDetails?: Partial<BlockedMonitoringPeriodDetails>
}

export const getBlockedMonitoringPeriodDetails = (
  error: unknown,
): BlockedMonitoringPeriodDetails | null => {
  const body = (error as { response?: BlockedMonitoringPeriodBody } | undefined)?.response

  if (body?.errorCode !== BLOCKED_MONITORING_PERIOD_CODE) return null

  return {
    carbonInstances: body.errorDetails?.carbonInstances ?? [],
    blockedMonitoringPeriods: body.errorDetails?.blockedMonitoringPeriods ?? [],
  }
}
